import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

export function generalElementAnimations() {
  document.addEventListener('DOMContentLoaded', () => {
    if (typeof gsap === 'undefined') return;
    gsap.registerPlugin(ScrollTrigger);

    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const baseEase = 'power2.out';

    gsap.utils.toArray('.text-content .row').forEach((row) => {
      if (reduce) {
        gsap.set(row, { autoAlpha: 1, scale: 1 });
        return;
      }
      gsap.from(row, {
        autoAlpha: 0,
        scale: 0.985,
        duration: 0.8,
        ease: baseEase,
        clearProps: 'transform,opacity',
        scrollTrigger: {
          trigger: row,
          start: 'top 80%',
          toggleActions: 'play none none reverse',
        }
      });
    });

    gsap.utils.toArray('.feature-image .container-image img').forEach((img) => {
      if (reduce) {
        gsap.set(img, { autoAlpha: 1, filter: 'none', scale: 1 });
        return;
      }
      gsap.fromTo(img,
        { autoAlpha: 0.65, filter: 'blur(4px)', scale: 1.02 },
        {
          autoAlpha: 1,
          filter: 'blur(0px)',
          scale: 1,
          duration: 1,
          ease: baseEase,
          clearProps: 'filter,transform,opacity',
          scrollTrigger: {
            trigger: img,
            start: 'top 85%',
            toggleActions: 'play none none reverse',
          }
        }
      );
    });
    gsap.utils.toArray('[class$="__main-title"]').forEach((title) => {
      gsap.from(title, {
        autoAlpha: 0,
        y: 20,
        duration: 0.8,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: title,
          start: 'top 85%',
          toggleActions: 'play none none reverse',
        }
      });
    });
  });
}